// extracted by mini-css-extract-plugin
export default {"MostPopular":"eM5bNMVB","Tag":"WtxcHhLh","leftSide":"mX6mEMH1","light":"DhKxEJrF"};